
define('template!portalImportsTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="imports-card">\n  <div class="imports-card__title">\n    ' +
((__t = ( _.i18n('portalImports.title', null, 'Portal imports') )) == null ? '' : __t) +
'\n  </div>\n\n  ';
 if (unavailable) { ;
__p += '\n    <p class="imports-card__warning">\n      ' +
((__t = ( _.i18n('portalImports.unavailable', null,
        'Could not reach the scheduler, so the last run dates are unknown.') )) == null ? '' : __t) +
'\n    </p>\n  ';
 } ;
__p += '\n\n  <table class="imports-table">\n    ';
 _.each(jobs, function (job) { ;
__p += '\n      <tr class="imports-row ' +
((__t = ( job.failing ? 'is-failing' : '' )) == null ? '' : __t) +
'">\n        <td class="imports-row__label">\n          ' +
((__t = ( job.label )) == null ? '' : __t) +
'\n          ';
 if (job.schedule) { ;
__p += '\n            <span class="imports-row__schedule">' +
((__t = ( job.schedule )) == null ? '' : __t) +
'</span>\n          ';
 } ;
__p += '\n        </td>\n\n        <td class="imports-row__dates">\n          ';
 if (!job.scheduled) { ;
__p += '\n            <span class="imports-row__missing">\n              ' +
((__t = ( _.i18n('portalImports.noJob', null, 'No job found for') )) == null ? '' : __t) +
' ' +
((__t = ( job.lookedFor )) == null ? '' : __t) +
'\n            </span>\n          ';
 } else { ;
__p += '\n            <span class="imports-row__success">\n              ';
 if (job.lastSuccess) { ;
__p += '\n                ' +
((__t = ( _.i18n('portalImports.lastRun', null, 'Last successful run') )) == null ? '' : __t) +
'\n                <strong>' +
((__t = ( job.lastSuccess )) == null ? '' : __t) +
'</strong>\n              ';
 } else { ;
__p += '\n                ' +
((__t = ( _.i18n('portalImports.never', null, 'Never run successfully') )) == null ? '' : __t) +
'\n              ';
 } ;
__p += '\n            </span>\n            ';
 if (job.failing) { ;
__p += '\n              <span class="imports-row__failed">\n                ' +
((__t = ( _.i18n('portalImports.lastFailure', null, 'Last run failed') )) == null ? '' : __t) +
'\n                <strong>' +
((__t = ( job.lastError )) == null ? '' : __t) +
'</strong>\n              </span>\n            ';
 } ;
__p += '\n          ';
 } ;
__p += '\n        </td>\n\n        <td class="imports-row__action">\n          ';
 if (job.scheduled) { ;
__p += '\n            ';
 if (job.started) { ;
__p += '\n              <span class="imports-row__started">\n                ' +
((__t = ( _.i18n('portalImports.started', null, 'Started — it runs in the background') )) == null ? '' : __t) +
'\n              </span>\n            ';
 } else { ;
__p += '\n              <button type="button" class="btn btn-sm js-run" data-key="' +
((__t = ( job.key )) == null ? '' : __t) +
'">\n                ' +
((__t = ( _.i18n('portalImports.run', null, 'Run now') )) == null ? '' : __t) +
'\n              </button>\n            ';
 } ;
__p += '\n          ';
 } ;
__p += '\n        </td>\n      </tr>\n    ';
 }); ;
__p += '\n  </table>\n\n  <p class="imports-card__error js-error"></p>\n</div>\n';

}
return __p
};});

